import React from "react";
import MSK from "../../../../images/MetaMask_Fox.svg";
import chainConfig from "../../../../common/utils/chain";

interface NetworkConfig {
  chainId: string;
  chainName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrls: string[];
  blockExplorerUrls?: string[];
}

interface AddNetworkToMetamaskProps {
  networkKey?: keyof typeof chainConfig;
  customNetwork?: NetworkConfig;
  buttonText?: string;
}

const AddNetworkToMetamask: React.FC<AddNetworkToMetamaskProps> = ({
  networkKey = (process.env.REACT_APP_BASE_UNIT?.toLowerCase() as keyof typeof chainConfig) ||
    "luxe",
  customNetwork,
  buttonText = process.env.REACT_APP_BASE_NAME,
}) => {
  const getNetworkConfig = (): NetworkConfig => {
    if (customNetwork) {
      return {
        ...customNetwork,
        chainId: customNetwork.chainId,
        rpcUrls: [customNetwork.rpcUrls[0]],
        blockExplorerUrls: customNetwork.blockExplorerUrls
          ? [customNetwork.blockExplorerUrls[0]]
          : undefined,
      };
    }

    const network =
      chainConfig[networkKey.toLowerCase() as keyof typeof chainConfig];
    return {
      ...network,
      chainId: network.chainId,
      rpcUrls: [network.rpcUrls[0]],
      blockExplorerUrls: network.blockExplorerUrls
        ? [network.blockExplorerUrls[0]]
        : undefined,
    };
  };

  const addNetworkToMetamask = async () => {
    if (typeof window.ethereum !== "undefined") {
      try {
        const networkConfig = getNetworkConfig();
        await window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [networkConfig],
        });
      } catch (error: any) {
        if (error.code === 4902) {
          try {
            const networkConfig = getNetworkConfig();
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [networkConfig],
            });
          } catch (innerError: any) {
            alert(`Failed to add network: ${innerError.message}`);
          }
        } else if (error.code === -32002) {
          alert("Network addition request is already pending in MetaMask");
        } else if (error.message.includes("already exists")) {
          alert("Network is already present in MetaMask");
        } else {
          alert(`Error adding network: ${error.message}`);
        }
      }
    } else {
      alert("Please install MetaMask to add the network");
    }
  };

  return (
    <div className="mb-3 mt-2">
      <button
        type="button"
        className="btn btn-sm bs-btn-network"
        onClick={addNetworkToMetamask}
      >
        <span style={{ marginRight: "5px" }}>
          <img
            src={MSK}
            alt="MetaMask Icon"
            height={16}
            width={16}
            style={{ marginBottom: "2px" }}
          />
        </span>
        Add to {buttonText}
      </button>
    </div>
  );
};

export default AddNetworkToMetamask;
